import { useTranslation } from 'react-i18next';
import type { IEquipmentAsset } from '../equipment.types';
import { EquipmentFloorPlan } from './EquipmentFloorPlan/EquipmentFloorPlan';
import styles from './EquipmentSiteMap.module.css';

interface IEquipmentSiteMapProps {
  siteId: string | null;
  siteName: string | null;
  selectedAsset: IEquipmentAsset | null;
}

export function EquipmentSiteMap({ siteId, siteName, selectedAsset }: IEquipmentSiteMapProps) {
  const { t } = useTranslation();
  const selectedFloorId = selectedAsset?.floorId ?? null;
  const selectedFloorNick = selectedAsset?.floorNick ?? null;

  /** Only labelled once an asset pins the map to a real site + floor. */
  const canvasLabel =
    siteName && selectedFloorNick
      ? t('equipment.map.sitePlanForFloor', { name: siteName, floor: selectedFloorNick })
      : null;

  return (
    <section className={styles.panel}>
      <header className={styles.header}>
        <h2 className={styles.title}>{t('equipment.map.title')}</h2>
      </header>
      <div className={styles.canvas}>
        {canvasLabel && <div className={styles.canvasLabel}>{canvasLabel}</div>}
        {siteId && selectedFloorId && selectedAsset ? (
          <EquipmentFloorPlan
            siteId={siteId}
            floorId={selectedFloorId}
            asset={selectedAsset}
          />
        ) : (
          <div className={styles.placeholder}>
            <span>{t('equipment.map.empty')}</span>
          </div>
        )}
      </div>
    </section>
  );
}
